import { Component, OnInit } from '@angular/core';

/* Services */

import { AuthService } from '../../core/services/auth/auth.service';
import { CentralAtendimentoService } from '../../core/services/central-atendimento/central-atendimento.service';
import { ConfiguracaoService } from '../../core/services/configuracoes/configuracao.service';
import { podeVerLiberacoesFinanceiro } from '../../core/services/dashboard/financeiro/dashboard-liberacoes-financeiro.service';
import { estaBloqueado, permissoesDoGrupo } from '../../core/permissoes/permissoes';

/* Models */

import { Configuracao } from '../../core/models/configuracoes/configuracao';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.css'],
    preserveWhitespaces: false,
    standalone: false
})

export class NavBarComponent implements OnInit {
  menuInterno: boolean = true;

  /* Configurações */

  configuracao: Configuracao = null;

  /* Layout */

    /* Cores */

    corLink: string = "rgba(255, 255, 255, .5)";
    corMenu: string = "";

    /* Logomarca */

    logomarca: string = "";

  /* Storage */

  fullname: string = "";
  is_master: boolean = false;
  is_manager: boolean = false;
  is_master_seller: boolean = false;
  is_diretor: boolean = false;
  is_financeiro: boolean = false;
  guidclientenapis: string = "";
  flag_gerencia_permissoes: boolean = false;
  flag_menu_integracoes: string = null;
  link_bi: string = "";
  seller_ver_aba_call_center: boolean = false;
  flag_tira_foto_odometro: boolean = (localStorage.getItem("flag_tira_foto_odometro") == "true");
  token_innersac: string = localStorage.getItem("token_innersac");
  link_innersac: string = localStorage.getItem("link_innersac");
  usa_pabx: boolean = false;
  usa_kanban: boolean = false;
  usa_whatsappoficial: boolean = false;
  usa_contrato: boolean = false;
  softphoneMensagem: string = "";
  softphoneConectado: boolean = false;
  softphoneConectando: boolean = false;

  get nomeResumido(): string {
    return (this.fullname || '').trim().split(/\s+/).slice(0, 2).join(' ');
  }

  get statusSoftphoneDescricao(): string {
    return this.softphoneConectando ? 'Conectando' : this.softphoneConectado ? 'Disponível' : 'Indisponível';
  }

  constructor(
    private authService: AuthService,
    private centralAtendimentoService: CentralAtendimentoService,
    private configuracaoService: ConfiguracaoService
  ) { }

  ngOnInit() {
    /* Emmiter */

    this.receberAtualizacao();
    this.receberStatusTelefonia();

    this.atualizarStorage();
    this.carregarDados();
    this.verificarLayout();
  }

  /* Ações */

  abrirLinkBI() {
    window.open(this.link_bi, "_blank");
  }

  alternarMenuInterno() {
    this.menuInterno = !this.menuInterno;
  }

  sair() {
    this.authService.desautorizar(true);
  }

  atualizarStatusSoftphone() {
    this.centralAtendimentoService.telefoniaAtualizarStatus();
  }

  /* Dados */

  carregarDados() {
    /* Configurações */

    this.configuracaoService.getByGuidClienteNapis().subscribe(
      configuracoes => this.configuracao = configuracoes,
      error => { console.log("Erro: " + error) },
      () => {

      }
    );
  }

  receberStatusTelefonia() {
    this.centralAtendimentoService.telefoniaStatusEmitter.subscribe(
      status => {
        if (status != null) {
          this.softphoneConectado = status.conectado;
          this.softphoneConectando = status.conectando;
          this.softphoneMensagem = status.mensagem;
        }
      }
    );
  }

  /* Emmiter */

  receberAtualizacao() {
    this.authService.navBarEmitter.subscribe(
      navBar => {
        this.atualizarStorage();
      }
    );
  }

  /* Layout */

  get isNapis(): boolean {
    return this.logomarca === 'assets/login/napis-force.png';
  }

  get corSubmenu(): string {
    return this.isNapis ? '#ffffff' : this.corMenu;
  }

  get corItemSubmenu(): string {
    return this.isNapis ? '#243b53' : this.corLink;
  }

  verificarLayout() {
    /* Empresa */

    if (window.location.href.indexOf("aokisistemas") > -1) {
      /* Aoki */

      this.corMenu = "#005aae";

      this.logomarca = "assets/logo_aoki_preto.png";
    } else if (window.location.href.indexOf("portal.cirobottini") > -1) {
      /* Bottini */

      this.corMenu = "#ef7e16";

      this.logomarca = "assets/logo_bottini_branco.png";
    } else if (window.location.href.indexOf("portal.2bdigitall") > -1) {
      /* 2B */

      this.corLink = "rgba(0, 0, 0, .5)";
      this.corMenu = "#f8f9fa";

      this.logomarca = "assets/logo_2bdigital_branco.png";
    } else {
      this.corMenu = "#00679a";
      this.corLink = "#edf4fc";

      this.logomarca = "assets/login/napis-force.png";
    }
  }

  /* Storage */

  atualizarStorage() {
    this.fullname = localStorage.getItem("fullname");
    this.is_master = (localStorage.getItem("is_master") == "true");
    this.is_manager = (localStorage.getItem("is_manager") == "true");
    this.is_master_seller = (localStorage.getItem("is_master_seller") == "true");
    this.is_diretor = (localStorage.getItem("is_diretor") == "true");
    this.is_financeiro = (localStorage.getItem("is_financeiro") == "true");
    this.guidclientenapis = (localStorage.getItem("guidclientenapis") || "").toUpperCase();
    this.flag_menu_integracoes = localStorage.getItem("flag_menu_integracoes");
    this.flag_gerencia_permissoes = localStorage.getItem("flag_gerencia_permissoes") == "true"
      || localStorage.getItem("flag_gerencia_permissoes") == "1";
    this.link_bi = localStorage.getItem("link_bi");
    this.seller_ver_aba_call_center = (localStorage.getItem("seller_ver_aba_call_center") == "true");
    this.usa_pabx = (localStorage.getItem("usa_pabx") == "true");
    this.usa_kanban = (localStorage.getItem("usa_kanban") == "true");
    this.usa_whatsappoficial = (localStorage.getItem("usa_whatsappoficial") == "true");
    this.usa_contrato = (localStorage.getItem("usa_contrato") == "true");
  }

  bloqueado(chave: string): boolean {
    return estaBloqueado(chave);
  }

  get podeVerIntegracoes(): boolean {
    return (this.flag_menu_integracoes == null || ['A', 'T'].includes(this.flag_menu_integracoes)) && (this.is_master
      || this.is_manager
      || this.is_master_seller
      || this.is_diretor
      || this.is_financeiro);
  }

  get podeVerClienteIntegracoes(): boolean {
    return this.flag_gerencia_permissoes && ['N', 'T'].includes(this.flag_menu_integracoes);
  }

  get podeVerControleIntegracoes(): boolean {
    return this.guidclientenapis === "A65C9C67-A1F9-470E-9534-17FB0E6CC516"
      && this.flag_gerencia_permissoes
      && (this.flag_menu_integracoes == null || ['A', 'T'].includes(this.flag_menu_integracoes));
  }

  get podeVerLiberacoesFinanceiro(): boolean {
    return podeVerLiberacoesFinanceiro(this.guidclientenapis, this.is_financeiro, this.is_diretor);
  }

  /* Dashboard: regra de perfil/config de cada item + bloqueio por usuário */

  dashboardVisivel(chave: string): boolean {
    if (estaBloqueado(chave)) return false;
    switch (chave) {
      case 'dash_bi':
        return this.link_bi != null && this.link_bi != '';
      case 'dash_liberacoes_financeiro':
        return this.podeVerLiberacoesFinanceiro;
      case 'dash_venda_interna':
      case 'dash_venda_interna_gerencial':
      case 'dash_venda_interna_whatsapp':
      case 'dash_quilometragens':
        return this.is_master || this.is_manager || this.is_master_seller || this.is_diretor;
      default:
        return true;
    }
  }

  get algumDashboardVisivel(): boolean {
    return permissoesDoGrupo('Menu Dashboard').some(p => this.dashboardVisivel(p.chave));
  }
}
